module.exports = __webpack_public_path__ + "static/media/overview.65c546df.jpg";